export const ROLES = {
  ADMIN: "admin",
  TENANT_ADMIN: "tenant_admin",
  USER: "user",
  REPORTER: "reporter",
  VIEWER: "viewer",
} as const;

export function rolesFromGroups(groups: unknown): { superAdmin: boolean; workspaceRoles: string[] } {
  const workspaceRoles = new Set<string>();
  let superAdmin = false;
  if (!Array.isArray(groups)) return { superAdmin, workspaceRoles: [] };
  for (const raw of groups) {
    const segments = String(raw).trim().replace(/^\/+/, "").split("/").filter(Boolean);
    if (segments.length === 1 && segments[0] === "admin") {
      superAdmin = true;
    } else if (segments.length >= 2) {
      const name = segments[segments.length - 1];
      if (name === "admin") workspaceRoles.add(ROLES.TENANT_ADMIN);
      else if (name === "user" || name === "reporter" || name === "viewer") workspaceRoles.add(name);
    }
  }
  return { superAdmin, workspaceRoles: [...workspaceRoles] };
}

export function rolesOf(profile: Record<string, unknown> | undefined): string[] {
  const groups = (profile?.groups as unknown) ?? (profile?.user as { groups?: unknown } | undefined)?.groups;
  const { superAdmin, workspaceRoles } = rolesFromGroups(groups);
  const roles = [...workspaceRoles];
  if (superAdmin) roles.unshift(ROLES.ADMIN);
  return roles;
}

export function isSuperAdmin(roles: string[]): boolean {
  return roles.includes(ROLES.ADMIN);
}

export function canCreateTickets(roles: string[]): boolean {
  if (isSuperAdmin(roles)) return true;
  return roles.includes(ROLES.TENANT_ADMIN) || roles.includes(ROLES.USER);
}
